export function PressSection() {
  const socialLinks = [
    {
      icon: 'ri-instagram-fill',
      url: 'https://www.instagram.com/prv.creativve?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
      label: 'Instagram'
    },
    {
      icon: 'ri-tiktok-fill',
      url: 'https://tiktok.com/',
      label: 'TikTok'
    },
    {
      icon: 'ri-facebook-fill',
      url: 'https://facebook.com/',
      label: 'Facebook'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto">
        <h3 className="text-sm uppercase tracking-wider text-center text-gray-600 mb-12">
          Follow Us
        </h3>

        {/* Social Media Section */}
        <div className="flex justify-center items-center gap-6">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
              className="w-14 h-14 flex items-center justify-center bg-gray-900 rounded-full hover:bg-gray-700 transition-colors cursor-pointer"
            >
              <i className={`${social.icon} text-2xl text-white`}></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}